export function isSpecialDefaultGallection(gallection) {
    var _gallection, _gallection1;
    if (((_gallection = gallection) === null || _gallection === void 0 ? void 0 : _gallection.type) === 'private_collection') {
        return gallection.name === 'Private';
    }
    return ((_gallection1 = gallection) === null || _gallection1 === void 0 ? void 0 : _gallection1.name) === 'Featured';
}
